import axios from 'axios'
import {
  CHECK,
  LOGIN,
  LOGOUT,
  CHANGE_LINES,
  LOGIN_ROLE,
  LOGIN_PLANTS,
  LOGIN_USER,
  LOGIN_PASSWORD,
  SET_NAV_MINI,
  SET_SUB_MENU,
  SET_CLIENT,
  SET_SUB_MENU_DASHBOARD,
  SET_HAS_DASHBOARDS
} from './mutation-types'
import * as helper from "../../helpers/global";

/* eslint-disable no-param-reassign */
export default {
  [CHECK](state) {
    var auth = false
    if (state.token) {
      if (typeof state.token.Token === 'undefined' || state.token.Token === null) {
        auth = false
      } else {

       var expiry = helper.getTokenExpiry()
       var dateNow = helper.getDateNowFormatted()
     
        if (dateNow < expiry) {
         
          auth = true
        }else{
         
          auth = false
          state.token = null
        }
      }
    } else {
      auth = false
    }
    state.authenticated = auth

    if (state.authenticated) {
      axios.defaults.headers.common.Authorization = `Bearer ${state.token.Token}`
    }else{
      axios.defaults.headers.common.Authorization = ''
    }
  },

  [LOGIN](state, token) {
    state.authenticated = true
    state.token = token
    axios.defaults.headers.common.Authorization = `Bearer ${token.Token}`
  },
  [LOGIN_ROLE](state, token) {
    // alert(state.role_id)
    // alert(state.is_admin)
    state.role_id = token.role_id
    state.role_name = token.name
    // alert(state.role_name)
    state.is_admin = token.is_admin
  },
  [LOGIN_PLANTS](state, token) {
    state.plants = token
  },
  [LOGIN_USER](state, payload) {
    state.user = payload.Username
    state.password_expires = payload.ExpirationDate
    // alert(state.user)
  },
  [LOGIN_PASSWORD](state, password) {
    state.password = password
    // alert(state.user)
  },
  [LOGOUT](state) {
    state.authenticated = false
    state.token = null
    state.client = null
    state.password_expires = null
    state.user = null
    state.has_dashboards=null
    // state.role_id = null
    // state.is_admin = null
    axios.defaults.headers.common.Authorization = ''
  },

  [CHANGE_LINES](state, lines) {
    state.token.user.lines = lines
  },
  [SET_NAV_MINI](state, payload) {
    state.mini = payload
  },
  [SET_SUB_MENU](state, payload) {
    state.sub_menu = payload
  },
  [SET_SUB_MENU_DASHBOARD](state, payload) {
    state.sub_menu_dashboard = payload
  },
  [SET_CLIENT](state, payload) {
    state.client = payload
  },
  [SET_HAS_DASHBOARDS](state, payload) {
    state.has_dashboards = payload
  }
}
